import React from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../imageWithBasePath'
import { all_routes } from '../../../feature-module/router/all_routes'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-bg">
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-01.png"
            className="footer-bg-1"
            alt=""
          />
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-02.png"
            className="footer-bg-2"
            alt=""
          />
        </div>
        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-4">
              <div className="footer-logo">
                <ImageWithBasePath src="assets/img/logoMTU.jpg" alt="" width={70}/>
              </div>
              {/* <div className="col-lg-7">
                <div className="footer-about">
                  <h6>{t('footer.about.title')}</h6><br />
                  <p className='col-11'>
                    {t('footer.about.description')}
                  </p>
                  <div className="d-flex align-items-center">
                    <Link to="#" className="me-2">
                      <ImageWithBasePath src="assets/img/icon/appstore.svg" alt="" />
                    </Link>
                    <Link to="#">
                      <ImageWithBasePath src="assets/img/icon/googleplay.svg" alt="" />
                    </Link>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-12">
                <div className="row row-gap-4">
                  {/* <div className="col-lg-3">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">For Instructor</h5>
                      <ul>
                        <li>
                          <Link to={all_routes.courseGrid}>Search Mentors</Link>
                        </li>
                        <li>
                          <Link to={all_routes.login}>Login</Link>
                        </li>
                        <li>
                          <Link to={all_routes.register}>Register</Link>
                        </li>
                        <li>
                          <Link to={all_routes.courseList}>Booking</Link>
                        </li>
                        <li>
                          <Link to={all_routes.studentDashboard}>Students Dashboard</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">For Student</h5>
                      <ul>
                        <li>
                          <Link to="#">Appointments</Link>
                        </li>
                        <li>
                          <Link to={all_routes.instructorMessage}>Chat</Link>
                        </li>
                        <li>
                          <Link to={all_routes.login}>Login</Link>
                        </li>
                        <li>
                          <Link to={all_routes.register}>Register</Link>
                        </li>
                        <li>
                          <Link to={all_routes.instructorDashboard}>
                            Instructor Dashboard
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                  <div className="col-lg-12">
                    <div className="footer-widget footer-contact">
                      {/* <h5 className="footer-title">Newsletter</h5>
                      <div className="subscribe-input">
                        <form action="#">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter your Email Address"
                          />
                          <button
                            type="submit"
                            className="btn btn-primary btn-sm inline-flex align-items-center"
                          >
                            <i className="isax isax-send-2 me-1" />
                            Subscribe
                          </button>
                        </form>
                      </div> */}
                      <h6 className="footer-title mb-4">{t('footer.company.name')}</h6>
                      <div className="footer-contact-info d-flex flex-column align-center gap-3 gap-md-5 flex-md-row">
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-20.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.address')}</p>
                        </div>
                        <div className="footer-address d-flex align-items-center">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-19.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.email')}</p>
                        </div>
                        <div className="footer-address d-flex align-items-center mb-3">
                          <ImageWithBasePath
                            src="assets/img/icon/icon-21.svg"
                            alt="Img"
                            className="img-fluid me-2"
                          />
                          <p>{t('footer.company.phone')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Đây là Privacy Policy và Terms &amp; Conditions*/}

        {/* <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2">
              <div className="col-md-6">
                <div className="text-center text-md-start">
                  <p className="text-white">
                    Copyright © 2025 DreamsLMS. All rights reserved.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <ul className="d-flex align-items-center justify-content-center justify-content-md-end footer-link">
                    <li>
                      <Link to={all_routes.termsConditions}>Terms &amp; Conditions</Link>
                    </li>
                    <li>
                      <Link to={all_routes.privacyPolicy}>Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </footer>
      {/* /Footer */}
    </>
  )
}

export default Footer